module.exports = __webpack_public_path__ + "static/media/git.6a80a853.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/git.png
// module id = 101
// module chunks = 0